export const ACTIONS_SEARCH_PLACEHOLDER =
  'Search by flow name, person, title, or company...';

export const NEW_ACTION = 'New action';
